module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container push-top"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('h2', {
    staticClass: "is-pulled-left"
  }, [_vm._v(_vm._s(_vm.$t('navigation.activity')))]), _vm._v(" "), _c('form', {
    staticClass: "propsal-filter is-pulled-right"
  }, [_c('span', {
    staticClass: "filter-by"
  }, [_vm._v(_vm._s(_vm.$t('filters.filter_by')) + " ")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.filterDocumentOptions,
      "placeholder": _vm.$t('filters.proposal_filter_options.all_proposals'),
      "track-by": "id",
      "label": "title",
      "showLabels": false
    },
    model: {
      value: (_vm.filterDocument),
      callback: function($$v) {
        _vm.filterDocument = $$v
      },
      expression: "filterDocument"
    }
  }), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.filterActionsOptions,
      "placeholder": _vm.$t('filters.action_filter_options.all_actions'),
      "track-by": "value",
      "label": "label",
      "showLabels": false
    },
    model: {
      value: (_vm.filterActions),
      callback: function($$v) {
        _vm.filterActions = $$v
      },
      expression: "filterActions"
    }
  }), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.filterTeamMemberOptions,
      "placeholder": _vm.$t('filters.team_filter_options.everyone'),
      "track-by": "id",
      "label": "name",
      "showLabels": false
    },
    model: {
      value: (_vm.filterTeamMember),
      callback: function($$v) {
        _vm.filterTeamMember = $$v
      },
      expression: "filterTeamMember"
    }
  })], 1)])]), _vm._v(" "), (_vm.activities !== false && _vm.activities.length <= 0 && _vm.pagination.currentPage === 0) ? _c('div', {
    staticClass: "no-activity"
  }, [_c('img', {
    attrs: {
      "src": "/images/sad.png"
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('activity.no_activity_msg_title')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('activity.no_activity_msg_body')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "activity-wrapper"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn"
    }
  }, [(_vm.activities !== false && _vm.activities.length > 0 && _vm.activitiesToday.length > 0) ? _c('div', {
    staticClass: "activity-date"
  }, [_c('hr'), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('activity.today')))]), _vm._v(" "), _c('ul', _vm._l((_vm.activitiesToday), function(activity) {
    return _c('activity-line-item', {
      key: activity.id,
      attrs: {
        "activity": activity
      }
    })
  }))]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn"
    }
  }, [(_vm.activities !== false && _vm.activities.length > 0 && _vm.activitiesYesterday.length > 0) ? _c('div', {
    staticClass: "activity-date"
  }, [_c('hr'), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('activity.yesterday')))]), _vm._v(" "), _c('ul', _vm._l((_vm.activitiesYesterday), function(activity) {
    return _c('activity-line-item', {
      key: activity.id,
      attrs: {
        "activity": activity
      }
    })
  }))]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn"
    }
  }, [(_vm.activities !== false && _vm.activities.length > 0 && _vm.activitiesAllTime.length > 0) ? _c('div', {
    staticClass: "activity-date"
  }, [_c('hr'), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('activity.all_time')))]), _vm._v(" "), _c('ul', _vm._l((_vm.activitiesAllTime), function(activity) {
    return _c('activity-line-item', {
      key: activity.id,
      attrs: {
        "activity": activity
      }
    })
  }))]) : _vm._e()]), _vm._v(" "), (_vm.showInfiniteLoadingIndicator) ? _c('loading-indicator') : _vm._e()], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5beb8974","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Activity.vue
// module id = 528
// module chunks = 0